module.exports = __webpack_public_path__ + "static/media/logo.8ecd7a7b.png";